import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ProjectRelationRole} from '../models/project-relation-role';
import {ProjectRelationVw, ProjectRelation} from '../models/project-relation';
import {PageResponse} from '../models/page-response';
import {Company} from '../models/company';
import {ProjectReferenceAttributeResponse} from '../models/project-reference-attribute-response';
import {ProjectReferenceContractAttributesResponse} from '../models/project-reference-contract-attributes-response';
import {ProjectReferenceContractAttributesUpdateRequest} from '../models/project-reference-contract-attributes-update-request';

export interface ProjectReferenceContractAttributesService {
    getContractAttributes(refId: number): Observable<ProjectReferenceContractAttributesResponse>;
    putContractAttributes(request: ProjectReferenceContractAttributesUpdateRequest): Observable<ProjectReferenceContractAttributesResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectReferenceContractAttributesServiceImpl implements ProjectReferenceContractAttributesService {
    protected http = inject(HttpClient);


    getContractAttributes(refId: number): Observable<ProjectReferenceContractAttributesResponse> {
        return this.http.get<ProjectReferenceContractAttributesResponse>(`/api/v1/project-references/${refId}/contract-attributes`);
    }

    putContractAttributes(request: ProjectReferenceContractAttributesUpdateRequest): Observable<ProjectReferenceContractAttributesResponse> {
        return this.http.put<ProjectReferenceContractAttributesResponse>(
            `/api/v1/project-references/${request.projectReference}/contract-attributes`,
            request
        );
    }
}
